import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {UserService} from "../../core/services/user.service";
import {ToastrService} from "ngx-toastr";
import {AuthenticationService} from "../../authentication/authentication.service";
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'settings-tab',
    templateUrl: './settings.tab.html',
    styleUrls: ['./profile.page.scss']
})

export class ProfileSettingsTab implements AfterViewInit {
    @Output() onFormAdd = new EventEmitter();
    @ViewChild('usernameForm', { static: true }) usernameForm;
    @ViewChild('passwordForm', { static: true }) passwordForm;

    state: any = {
        isSubmitted: false,
        currentPassword: null,
        newUsername: null,
        newPassword: null,
        newPasswordConfirm: null
    };
    isCurrentPasswordTopFocus: boolean;
    isCurrentPasswordBottomFocus: boolean;
    isNewLogoinFocus: boolean;
    isNewPasswordFocus: boolean;
    public model: any;

    constructor(
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private userService: UserService,
        private angulartics2: Angulartics2
    ) {}

    ngAfterViewInit() {
        this.onFormAdd.emit(this.usernameForm);
        this.onFormAdd.emit(this.passwordForm);
        this.angulartics2.eventTrack.next({
            action: 'View Manage Password',
            properties: {category: 'Profile'}
        });
    }

    onUsernameSave() {
        if (!this.checkCurrentPassword(this.state.usernameCurrentPassword)) {
            return;
        }
        if (!this.state.newUsername) {
            this.toastr.error('Username field cannot be blank.');
            return;
        }
        this.userService.saveUsername(this.state.usernameCurrentPassword, this.state.newUsername)
            .subscribe((res) => {
                this.usernameForm.form.markAsPristine();
                this.clearUsername();
                this.authService.setToken(res['access_token']);
                this.toastr.success('Username successfully changed.');
            }, err => {
                console.log(err);
                this.toastr.error('Could not change username.');
            });
    }

    onPasswordSave() {
        if (!this.checkCurrentPassword(this.state.passwordCurrentPassword)) {
            return;
        }
        if (!this.state.newPasswordConfirm) {
            this.toastr.error('You must confirm new password.');
            return;
        }
        if (this.state.newPassword !== this.state.newPasswordConfirm) {
            this.toastr.error('The password and confirm passwords do not match.');
            return;
        }
        this.userService.savePassword(this.state.passwordCurrentPassword, this.state.newPassword)
            .subscribe(() => {
                this.passwordForm.form.markAsPristine();
                this.clearPassword();
                this.toastr.success('Password successfully changed.');
                this.angulartics2.eventTrack.next({
                    action: 'Change password',
                    properties: {category: 'Profile'}
                });
            }, err => {
                console.log(err);
                this.toastr.error('Could not change password.');
            });
    }

    checkCurrentPassword(currentPasswordField) {
        if (!currentPasswordField) {
            this.toastr.error('You must provide current password when changing username or password.');
            return false;
        }
        return true;
    }

    clearUsername() {
        this.state.usernameCurrentPassword = null;
        this.state.newUsername = null;
    }

    clearPassword() {
        this.state.passwordCurrentPassword = null;
        this.state.newPassword = null;
        this.state.newPasswordConfirm = null;
    }
}
